import { Component, OnInit } from '@angular/core';
import { faTerminal, IconDefinition } from '@fortawesome/pro-duotone-svg-icons';
import { IDynamicActionsBrickLayoutComponent } from '../i-dynamic-actions-brick-layout-component';

@Component({
   selector: 'samweb-dynamic-actions-brick-unknown-layout',
   templateUrl: './dynamic-actions-brick-unknown-layout.component.html',
   styleUrls: ['./dynamic-actions-brick-unknown-layout.component.scss'],
})
export class DynamicActionsBrickUnknownLayoutComponent implements IDynamicActionsBrickLayoutComponent, OnInit {
   public brickInstanceId: Readonly<string>;
   public noValidConfigIcon: IconDefinition = faTerminal;

   constructor() {}

   ngOnInit(): void {}
}
